import axios from "axios";

export default {
  namespaced: true,
  state: {
    glmaps: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    glmapsMessage: ''
  },
  mutations: {
    RECEIVED_GLMAPS(state, payload) {
      state.glmaps = payload;
      state.isReceiving = false;
    },
    RECEIVING_GLMAPS(state) {
      state.isReceiving = true;
    },
    RECEIVED_GLMAP(state, payload) {
      state = Object.assign(state, {
        glmaps: [...state.glmaps, payload],
        isReceiving: false,
      })
    },
    RECEIVING_GLMAP(state) {
      state.isReceiving = true;
    },
    UPDATED_GLMAP(state, payload) {
      let index = state.glmaps.findIndex(glmap => glmap._id === payload._id);
      state = Object.assign(state, {
        glmaps: state.glmaps.map((glmap, i) => {
          if (i === index) {
            return Object.assign({}, glmap, payload);
          }
          return glmap;
        }),
        isUpdating: false,
        glmapsMessage: 'GLMaps has been updating!',
      })
    },
    UPDATING_GLMAP(state) {
      state.isUpdating = true;
    },
    DELETED_GLMAP(state, payload) {
      let indexToDelete = state.glmaps.findIndex(glmap => glmap._id === payload._id);
      let glmaps = [...state.glmaps];
      glmaps.splice(indexToDelete, 1);
      state = Object.assign(state, {
        glmaps: [...glmaps],
        isDeleting: false,
        idToDelete: null,
        glmapsMessage: 'GLMap has been Deleted!',
      });
    },
    DELETING_GLMAP(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async getGLMapsRequest({dispatch}) {
      dispatch("receivingGLMaps");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/gl-maps';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "GET", url: url, headers: headers})
      .then(res => {
        dispatch("receiveGLMaps", res.data);
      })
    },
    async updateGLMapRequest({dispatch}, payload) {
      dispatch("updatingGLMap");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/gl-map/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      return axios({method: "PUT",url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateGLMap", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async insertGLMapRequest({dispatch}, payload) {
      dispatch("receivingGLMaps");
      let token = localStorage.getItem('token');
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let url = 'https://api.accountxc.com:3100/insert/gl-map';
      let data = payload;
      return axios({method: "POST", url: url, headers: headers, data: data})
      .then((response)=>{
        dispatch("receiveGLMap", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    deleteGLMapRequest({dispatch}, payload) {
      dispatch("deletingGLMap", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/delete/gl-map/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "DELETE", url: url, headers: headers}).then(() => {
        dispatch("deleteGLMap", {_id: payload._id});
      })
    },
    receiveGLMaps({commit}, payload) {
      commit("RECEIVED_GLMAPS", payload)
    },
    receivingGLMaps({commit}) {
      commit("RECEIVING_GLMAPS")
    },
    receiveGLMap({commit}, payload) {
      commit("RECEIVED_GLMAP", payload)
    },
    receivingGLMap({commit}) {
      commit("RECEIVING_GLMAP")
    },
    updateGLMap({commit}, payload) {
      commit("UPDATED_GLMAP", payload)
    },
    updatingGLMap({commit}) {
      commit("UPDATING_GLMAP")
    },
    deleteGLMap({commit}, payload) {
      commit("DELETED_GLMAP", payload)
    },
    deletingGLMap({commit}, payload) {
      commit("DELETING_GLMAP", payload)
    }
  },
};
